let svgNodeCache = {};

export function resetSvgNodeCache(): void {
  svgNodeCache = {};
}

export default svgNodeCache;
